import React from "react";
import { Plus, X as XIcon } from "lucide-react";

export const DobrasField = ({ cats, catMap, principalId, rows, onChange, existing = [], onRemoveExisting }) => {
  const used = new Set([principalId, ...existing.map((e) => e.category_id), ...rows.map((r) => r.v)].filter(Boolean));
  const available = cats.filter((c) => !used.has(c.id));

  const addRow = () =>
    onChange([...rows, { k: `d-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, v: "" }]);
  const setRow = (idx, v) => onChange(rows.map((r, i) => (i === idx ? { ...r, v } : r)));
  const removeRow = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const emptyRows = rows.filter((r) => !r.v).length;
  const canAdd = Boolean(principalId) && available.length > emptyRows;

  return (
    <div className="border border-white/10 p-3 space-y-2" data-testid="atleta-dobras-box">
      <div className="overline flex items-center justify-between gap-2">
        <span className="leading-tight">Dobras — categorias adicionais</span>
        <button
          type="button"
          data-testid="atleta-add-dobra-row"
          className="btn-ghost !py-1 !px-2 !text-xs inline-flex items-center gap-1 whitespace-nowrap shrink-0"
          onClick={addRow}
          disabled={!canAdd}
        >
          <Plus size={12} /> Adicionar dobra
        </button>
      </div>

      {existing.map((e) => (
        <div
          key={e.id}
          data-testid={`atleta-dobra-existing-${e.id}`}
          className="flex items-center gap-2 text-xs px-2 py-1.5 border border-[#C9A84C]/30 bg-[#C9A84C]/5"
        >
          <span className="flex-1 truncate">{catMap[e.category_id] || "—"}</span>
          <span className="text-[9px] tracking-widest text-[var(--text-secondary)]">
            {e.is_dobra ? "DOBRA" : "PRINCIPAL"}
          </span>
          <button
            type="button"
            data-testid={`atleta-dobra-existing-remove-${e.id}`}
            className="btn-ghost !p-1"
            onClick={() => onRemoveExisting(e)}
            aria-label="Remover inscrição"
            title="Remover esta inscrição"
          >
            <XIcon size={13} />
          </button>
        </div>
      ))}

      {rows.map((row, idx) => (
        <div key={row.k} className="flex items-center gap-2" data-testid={`atleta-dobra-row-${idx}`}>
          <select
            data-testid={`atleta-dobra-select-${idx}`}
            required
            className="input-field flex-1"
            value={row.v}
            onChange={(e) => setRow(idx, e.target.value)}
          >
            <option value="">Selecione a categoria da dobra {idx + 1}</option>
            {cats
              .filter((c) => !used.has(c.id) || c.id === row.v)
              .map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nome}
                </option>
              ))}
          </select>
          <button
            type="button"
            data-testid={`atleta-dobra-remove-${idx}`}
            className="btn-ghost !p-2"
            onClick={() => removeRow(idx)}
            aria-label="Remover dobra"
          >
            <XIcon size={14} />
          </button>
        </div>
      ))}

      {rows.length === 0 && existing.length === 0 && (
        <div className="text-[11px] text-[var(--text-secondary)]" data-testid="atleta-dobras-empty">
          Nenhuma dobra. O atleta ficará apenas na categoria principal.
        </div>
      )}
    </div>
  );
};
